import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/optix.png'


const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0" }
const _hoisted_3 = { class: "w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700" }
const _hoisted_4 = { class: "p-6 space-y-4 md:space-y-6 sm:p-8" }

import AuthSimpleLayout from "@/views/layouts/AuthSimpleLayout.vue";
import { useAuthStore } from "@/stores/auth";
import { useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const authStore = useAuthStore();
const router = useRouter();

async function handleLogin() {
    // await authStore.signIn("/ask");
    router.push("/ask");
}

async function handleLogout() {
    await authStore.signOut();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AuthSimpleLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("a", {
            href: "#",
            class: "flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white"
          }, [
            _createElementVNode("img", {
              class: "w-30 h-30 mr-2",
              src: _imports_0,
              alt: "logo"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white" }, " Optix by ITS ", -1)),
              _cache[1] || (_cache[1] = _createElementVNode("p", null, " Sign in using your Microsoft account ", -1)),
              (!_unref(authStore).isAuthenticated)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: handleLogin,
                    type: "button",
                    class: "w-full text-white bg-brand box-border border border-transparent hover:bg-brand-strong focus:ring-4 focus:ring-brand-medium shadow-xs font-medium leading-5 rounded-base text-sm px-4 py-2.5 focus:outline-none"
                  }, " Sign in "))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: handleLogout
                  }, " Logout "))
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})